import { Box, Button, Modal, Typography } from "@mui/material";
import { useProjectsContext } from "../../context/Projects/ProjectContext";

const DeleteOrgModal = () => {
  const { isDeleting, assignToDelete, toDelete, handleDelete } = useProjectsContext();
  const handleClose = () => {
    if (!isDeleting) {
      assignToDelete("");
    }
  };

  return (
    <Modal
      open={Boolean(toDelete)}
      onClose={handleClose}
      BackdropProps={{ sx: { backgroundColor: "rgba(29, 61, 77, 0.6)" } }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography component={"h3"}
          sx={{
            color: "#336B87",
            fontFamily: "Montserrat",
            fontWeight: "bold",
            fontSize: 20,
            textAlign: "center",
            mt: 3,
          }}>
          ¿Quieres eliminar esta planificación?
        </Typography>
        <Typography component={"p"}
          sx={{
            color: "rgba(0, 0, 0, 0.68)",
            fontFamily: "Montserrat",
            fontSize: 14,
            textAlign: "center",
          }}>
          Todo el contenido será eliminado
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Button
            variant="text"
            onClick={() => assignToDelete("")}
            disabled={isDeleting}
            sx={{
              backgroundColor: "#FFFFFF",
              color: "#FB3748",
              textTransform: "none",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 600,
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#FB3748",
                color: "#FFFFFF",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#336B87",
              color: "#FFFFFF",
              textTransform: "none",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 600,
              borderRadius: 2,
              ml: 1,
              "&:hover": {
                backgroundColor: "#1FC16B",
                color: "#FFFFFF",
              },
            }}
            disabled={isDeleting}
            onClick={() => {
              if (toDelete) handleDelete(toDelete);
            }}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteOrgModal;
